// extracted by mini-css-extract-plugin
module.exports = {"root":"TreeCheck_root__2c_Ej"};